// Funnel definition for Open Sesame Garage Doors lead quiz.
// Step types: 'single' (option cards), 'address', 'name', 'email', 'phone'.

export const FUNNEL_STEPS = [
  {
    id: 'homeowner',
    field: 'homeowner',
    question: 'Do you own your home?',
    type: 'single',
    columns: 2,
    options: [
      { id: 'yes', label: 'Yes', icon: 'Check', color: 'green' },
      { id: 'no', label: 'No', icon: 'X', color: 'red' },
    ],
  },
  {
    id: 'issue',
    field: 'issue',
    question: "What's going on with your garage door?",
    type: 'single',
    columns: 3,
    options: [
      { id: 'wont-open', label: "Won't open / close", icon: 'DoorClosed', color: 'blue' },
      { id: 'broken-spring', label: 'Broken spring', icon: 'Zap', color: 'amber' },
      { id: 'noisy', label: 'Noisy door', icon: 'Volume2', color: 'purple' },
      { id: 'off-track', label: 'Off track', icon: 'Unplug', color: 'orange' },
      { id: 'new-install', label: 'New installation', icon: 'PlusCircle', color: 'green' },
      { id: 'other', label: 'Something else', icon: 'HelpCircle', color: 'teal' },
    ],
  },
  {
    id: 'service',
    field: 'service_type',
    question: 'Are you looking to repair or replace?',
    type: 'single',
    columns: 2,
    options: [
      { id: 'repair', label: 'Repair', icon: 'Wrench', color: 'blue' },
      { id: 'replace', label: 'Replace', icon: 'RefreshCw', color: 'emerald' },
    ],
  },
  {
    id: 'address',
    question: "What's your property address?",
    subtitle: 'For verification only. We do not mail.',
    type: 'address',
  },
  {
    id: 'name',
    question: 'What is your name?',
    subtitle: 'Personal Information Is Safe & Secure.',
    type: 'name',
  },
  {
    id: 'email',
    question: "What's your email?",
    subtitle: 'We take privacy seriously. No spam!',
    type: 'email',
  },
  {
    id: 'phone',
    question: 'Complete This Final Step To See Results',
    type: 'phone',
  },
];

export const STEP_IDS = FUNNEL_STEPS.map((s) => s.id);

export function getStepIndex(stepId) {
  return STEP_IDS.indexOf(stepId);
}

export function getStep(stepId) {
  return FUNNEL_STEPS.find((s) => s.id === stepId);
}

export function optionLabel(stepId, optionId) {
  const step = getStep(stepId);
  if (!step || !step.options) return optionId;
  const opt = step.options.find((o) => o.id === optionId);
  return opt ? opt.label : optionId;
}

// Tailwind-safe color classes for colorful option icons.
export const ICON_COLORS = {
  green: { wrap: 'bg-green-50 border-green-200', icon: 'text-green-600' },
  emerald: { wrap: 'bg-emerald-50 border-emerald-200', icon: 'text-emerald-600' },
  red: { wrap: 'bg-red-50 border-red-200', icon: 'text-red-500' },
  blue: { wrap: 'bg-blue-50 border-blue-200', icon: 'text-blue-600' },
  amber: { wrap: 'bg-amber-50 border-amber-200', icon: 'text-amber-500' },
  purple: { wrap: 'bg-purple-50 border-purple-200', icon: 'text-purple-600' },
  orange: { wrap: 'bg-orange-50 border-orange-200', icon: 'text-orange-500' },
  teal: { wrap: 'bg-teal-50 border-teal-200', icon: 'text-teal-600' },
  slate: { wrap: 'bg-slate-50 border-slate-200', icon: 'text-slate-700' },
};
